import React, { useEffect, useState } from 'react'
import {config} from '../Constants';
import pretripIcon from "../imgs/pretrip.png"
import breakdownIcon from "../imgs/breakdown.png"
import scanIcon from '../imgs/work/qr-scan.png';
import passengerIcon from "../imgs/add-passenger.png"
import inspectionIcon from "../imgs/doc-check.png"
import {AppLauncher} from '@capacitor/app-launcher';
import {ApiService} from "../api/ApiService";
import {userStore} from "../api/AuthService";
import {Link} from "react-router-dom";
import { IonPage, IonHeader, IonToolbar, IonContent, IonFooter, createGesture } from '@ionic/react';
import Nav from './Nav';
import Toolbar from './Toolbar';
import { sidnavStore, SidenavState } from '../api/SidenavStore';
import { camera } from 'ionicons/icons';
import TripFirstIn from '../components/walkthrough/TripFirstIn';

const Trip = () => {

    const transfloClick = () => {
        ApiService.sendEventCommand('Tranflo Route', 'eventCheck', 'User has been routed to the Transflo app');
        const deepLink = `transflomobileplus://scan?recipientid=WSXI&sourceapp=westerndrivermobile&doctypes=TOD,BOL,TRP&driverid=${localStorage.getItem('username')?.toUpperCase()}&truckid=${userStore.getState().driver.unit}`;
        AppLauncher.openUrl({url: deepLink});
    }

    const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
    const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));
    
    const ref = React.useRef<HTMLInputElement>(null)

    useEffect(() => {
        gestureInit();
    }, [])

    const gestureInit = () => {
        const card = ref.current
        if (card) {
            const gesture = createGesture({
                el: card,
                gestureName: 'swipeMenu',
                onMove: (detail) => {
                    console.log("moving");
                },
                onEnd: (detail) => {
                    console.log("move ended");
                    toggleSidenav();
                }                 
            })
            gesture.enable();
        }
    }

    return (
    <TripFirstIn>
    <IonPage>
        <IonHeader>
            <IonToolbar color="primary">
                <Toolbar pageName="Trip"/>
            </IonToolbar>
        </IonHeader>
        <IonContent fullscreen color="light">
            <div ref={ref} onClick={() => close()} style={{height: "80vh"}}>
                <div className="item-container">
                    <div className="grid50">
                        <Link to="/trailertracking" className="image-button">
                            <div id="stock-map">
                                <p>Trailer Tracking</p>
                            </div>
                        </Link>
                        <Link to="/photoupload" className="image-button">
                            <div id="last-tarp">
                                <p>Tarp Photo</p>
                            </div>
                        </Link>
                        <div className="western-button-link" onClick={() => transfloClick()}>
                            <div id="centered">
                                <p style={{textAlign: "left"}}>Submit Paperwork<br/><span style={{color: "#D0A024", fontSize: "12px"}}>Transflo</span></p>
                                <img src={scanIcon} alt="scan"/>
                            </div>
                        </div>
                        <div>
                            {/* <Link className="western-button-link" to="/passenger">
                                <div>
                                    <img src={passengerIcon} alt="key" className="link-icon"/><p>Add Passenger</p>
                                </div>
                            </Link> */}
                            <Link className="western-button-link" to="/leasepurchase">
                                <div>
                                    <img src={inspectionIcon} alt="key" className="link-icon"/><p>Vehicle Inspection<br/><span style={{color: "#D0A024", fontSize: "12px"}}>Lease Purchase Program Only</span>
                                </p>
                                </div>
                            </Link>
                            <Link className="western-button-link"to="/traileridphotos" id="trailer-id">
                                <div>
                                <img src={camera} alt="key" className="link-icon"/><p>Trailer Plate Photos</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </IonContent>
        <IonFooter>
            <Nav pageName="Trip" />
        </IonFooter>
    </IonPage>
    </TripFirstIn>
    )
}

export default Trip
